var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiceLogo = function SvgDiceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 154 154"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1F81",
    d: "M67.375 5.557a19.25 19.25 0 0 1 19.25 0l47.434 27.386a19.25 19.25 0 0 1 9.625 16.672v54.771a19.25 19.25 0 0 1-9.625 16.671l-47.434 27.386a19.25 19.25 0 0 1-19.25 0l-47.434-27.386a19.25 19.25 0 0 1-9.625-16.671V49.615a19.25 19.25 0 0 1 9.625-16.671z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m72.653 113.306.06-72.633 8.658.007-.061 72.634z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M106.068 98.951 43.621 62.58l4.335-7.545 62.447 36.372z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m47.919 98.9 62.508-36.262-4.322-7.552-62.508 36.262z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 8,
    d: "M47.928 74.206 45.499 95l19.007 8.079M106.5 79l2.428-20.794-19.007-8.079"
  })));
};
export default SvgDiceLogo;